"use strict";
/**
 * @restor/shared-types — the single source of truth for API contracts.
 *
 * Every client (admin web, customer web, mini app, POS, KDS, courier app) and
 * the backend import from here. Nobody hand-writes a duplicate interface
 * (TZ §44).
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./api"), exports);
__exportStar(require("./error-codes"), exports);
__exportStar(require("./enums"), exports);
__exportStar(require("./rbac"), exports);
__exportStar(require("./events"), exports);
__exportStar(require("./models/tenant"), exports);
__exportStar(require("./models/identity"), exports);
__exportStar(require("./models/branch"), exports);
__exportStar(require("./models/catalog"), exports);
__exportStar(require("./models/order"), exports);
__exportStar(require("./models/operations"), exports);
__exportStar(require("./models/crm"), exports);
__exportStar(require("./models/inventory"), exports);
__exportStar(require("./models/platform"), exports);
__exportStar(require("./models/storefront"), exports);
//# sourceMappingURL=index.js.map